import React ,{  useState } from "react";

import Header from './components/Header'
import PodcastplayerStore from './components/Podcastplayer'
import Footer from './components/Footer'
import RmsRoutes from './routes/RmsRoutes'
import RmsProvider from './store/RmsProvider'


import { BrowserRouter as Router, Route, Link, Routes, Redirect, useLocation } from 'react-router-dom';

import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

function App() {
    const [mixcloudSlug, setMixcloudSlug] = useState('no-slug');


    return (
        <RmsProvider>
        <div>
            <Router >
                <Header/>
                    <PodcastplayerStore />
                <RmsRoutes/>
                <Footer/>

            </Router>
        </div>
        </RmsProvider>
        
    );
}



export default App;
